export const transferType = {
	virtual: "Virtual",
	pushToWarehouse: "PushToWarehouse",
};

const transferTypeDisplayLabels: Record<string, string> = {
	[transferType.virtual.toLowerCase()]: "Virtual",
	[transferType.pushToWarehouse.toLowerCase()]: "Push to Warehouse",
};

export const isVirtualTransfer = (type?: string | null) =>
	[transferType.virtual, transferType.pushToWarehouse].some((t) => (type ?? "").toLowerCase() === t.toLowerCase());

export const getTransferTypeDisplayLabel = (type?: string | null) =>
	transferTypeDisplayLabels[(type ?? "").toLowerCase()] ?? transferTypeDisplayLabels[transferType.virtual.toLowerCase()];
